module.exports = __webpack_public_path__ + "static/media/googleIcon.c26a67e3.svg";